import RocketsPage from '../components/RocketsPage';

const Rockets = () => <RocketsPage />;

export default Rockets;
